import script from "./FormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormComponent.vue?vue&type=style&index=0&id=d0b615c8&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0b615c8"]])

export default __exports__